import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(theme => ({
  drawerContent: {
    display: "flex",
    flexDirection: "column",
    height: "100%"
  },
  scrollableContent: {
    flex: 1,
    overflowY: "auto",
    paddingBottom: "1rem"
  },
  filterSection: {
    marginBottom: "1.5rem",
    "&:last-child": {
      marginBottom: 0
    }
  },
  sectionTitle: {
    margin: "0 0 1rem 0",
    fontSize: "1rem",
    fontWeight: 600,
    color: "#333"
  },
  sectionSubtitle: {
    margin: "0 0 0.5rem 0",
    fontSize: "0.82rem",
    fontWeight: 500,
    color: "#666"
  },
  inputSection: {
    "& .MuiTextField-root, & .MuiAutocomplete-root": {
      width: "100%"
    },
    "& .MuiInputBase-root": {
      backgroundColor: "#ffffff",
      borderRadius: "4px",
      "&:hover": {
        backgroundColor: "#f9f9f9"
      }
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#e0e0e0",
      borderWidth: "1px"
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#bdbdbd"
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.main,
      borderWidth: "2px"
    },
    "& .MuiAutocomplete-inputRoot": {
      padding: "10px 12px",
      gap: "4px",
      flexWrap: "wrap",
      minHeight: "56px",
      height: "auto"
    },
    "& .MuiAutocomplete-input": {
      minWidth: "120px !important",
      padding: "0 !important"
    },
    "& .MuiAutocomplete-endAdornment": {
      top: "50%",
      transform: "translateY(-50%)"
    }
  },
  dateRow: {
    display: "flex",
    gap: "0.75rem"
  },
  buttonsContainer: {
    paddingTop: "1rem",
    borderTop: "1px solid #e0e0e0",
    marginTop: "1rem"
  },
  clearButton: {
    marginBottom: "0.5rem"
  }
}));
